import { addColumnStmtInstruction } from './AddColumnStmt';
import { alterColumnStmtInstruction } from './AlterColumnStmt';
import { removeColumnStmtInstruction } from './RemoveColumnStmt';
import { removeDefaultColumnStmtInstruction } from './RemoveDefaultColumnStmt';
import { setDefaultColumnStmtInstruction } from './SetDefaultColumnStmt';
import { setTranslatableColumnStmtInstruction } from './SetTranslatableColumnStmt';
export const columnInstruction = `
### Columns

${addColumnStmtInstruction}
${removeColumnStmtInstruction}
${alterColumnStmtInstruction}
${setDefaultColumnStmtInstruction}
${removeDefaultColumnStmtInstruction}
${setTranslatableColumnStmtInstruction}
`;
//# sourceMappingURL=columnInstruction.js.map